"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const ro = require("redux-observable");
const files = require("./filesList");
const _metaschema = require("../../modules/metaschema/epics");
const _fileList = require("../../modules/files/list/epics");
const _folderTree = require("../../modules/files/tree/epics");
const _crud = require("../../modules/files/crud/epics");
const _preview = require("../../modules/files/preview/epics");
const metaschema = _metaschema.default('files');
const fileList = _fileList.default('files');
const quickSearch = _fileList.default('files-quicksearch');
const folderTree = _folderTree.default('files');
const importProject = _folderTree.default('import');
const folderBrowser = _folderTree.default('browser');
const crud = _crud.default('files');
const preview = _preview.default('files');
exports.allEpics = ro.combineEpics(crud.update, crud.createFolder, crud.deleteFile, crud.getTTL, crud.setTTL, files.bookmarkFile, files.unbookmarkFile, files.toggleNotifications, files.refreshFiles, files.projectFilelistColumns, files.fethProjectFilelistColumns, files.fetchProjects, preview.convert, preview.fetchTree, files.setFiltering, metaschema.fetchSchema, fileList.fetch, quickSearch.fetch, folderTree.fetchTree, folderTree.copyFiles, importProject.fetchTree, importProject.copyFiles, files.fetchProjects, files.fetchGroups, folderBrowser.fetchTree, files.saveProjectFilelistWidth, files.fetchProjectFilelistWidth, files.handleMissingItem, files.handleCopyMoveTarget);
//# sourceMappingURL=index.js.map